import { TenantContext } from '@/components';
import { processesRepo } from '@/constants/providers';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { ProcessKey } from './keys';
import { ProcessDetails } from '../domain';

export const useGetProcess = (id: number) => {
  const { currentSelectedTenant } = useContext(TenantContext);

  return useQuery<ProcessDetails>(
    [...ProcessKey.BY_ID(id), currentSelectedTenant?.id],
    () => processesRepo.getProcess(id),
    {
      enabled: !!id,
    },
  );
};
